export default __webpack_public_path__ + "static/media/ENGLISH_REMIX.5c168d6a.svg";